export const TIPOS_DESTINATARIOS = {
  CO: "Cliente",
  OU: "Outros",
  PE: "Perfil",
};
